import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormErrorsComponent } from 'src/app/components/form-errors/form-errors.component';
import { Cities } from 'src/app/models/cities/cities';
import { CitiesService } from 'src/app/services/cities.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-cities-modal',
  imports: [CommonModule, ReactiveFormsModule, FormErrorsComponent, MatDialogContent, MatDialogActions, MatDialogTitle],
  templateUrl: './cities-modal.component.html',
  styleUrls: ['./cities-modal.component.css']
})
export class CitiesModalComponent implements OnInit{
  form: FormGroup = new FormGroup({});
  stateList: any[] = [];

  constructor(
    private fb: FormBuilder,
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<CitiesModalComponent>,
    public CitiesService: CitiesService,
    public StateService: StateService,
    public _toastService: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any    
  ) {
    
    this.buildForm();

    if(this.data?.item){
      this.form.patchValue({...this.data?.item}); 
    }
    if(this.data?.view){
      this.form.disable();
    }

  } 

  ngOnInit(): void {
    this.getstate();
  }

  getstate(){
    this.StateService.getStates().subscribe({
      next: (res: any) => {
        this.stateList = res;
      }});
  }


  private buildForm(){
    this.form = this.fb.group({
          id: new FormControl(0),
          name: new FormControl('', [Validators.required, Validators.maxLength(100)]),
          stateId: new FormControl(0, [Validators.required, Validators.min(1)]),
          isEnabled: new FormControl(true)
    })
  }

  Accept() {
   
    const CitiesModel = this.form?.value as Cities;
    if(this.form.invalid) {
      this.form.markAllAsTouched();
      this._toastService.error("Por favor, complete todos los campos requeridos.");
      return;
    }
    if(this.data.mode == 'add' || this.data.mode == 'edit'){         
      this.save(CitiesModel);  
    }else if(this.data.mode == 'delete'){
      this.delete(CitiesModel.id);
    }
  }
  save(CitiesModel: Cities){    
    this.CitiesService.addCities(CitiesModel).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos guardados")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }
  delete(id: number){    
    this.CitiesService.deleteCities(id).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos eliminados correctamente!")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }

  closeDialog(): void {
    this.dialogRef.close(true);
  }

}
